module.exports = __webpack_public_path__ + "img/LEGAL-HMG.ebe8de7f.svg";